import { render, staticRenderFns } from "./commentRemarkDialog.vue?vue&type=template&id=0c5f7e14&scoped=true"
import script from "./commentRemarkDialog.vue?vue&type=script&lang=js"
export * from "./commentRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./commentRemarkDialog.vue?vue&type=style&index=0&id=0c5f7e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f7e14",
  null
  
)

export default component.exports